const _temp0 = require("./Audrey Tutt and Friends.png");
const _temp1 = require("./Black School Children.png");
const _temp2 = require("./Cars at Scenic Overlook.png");
const _temp3 = require("./Couple at Scenic Overlook.png");
const _temp4 = require("./Elkwallow Picnic Grounds Sign.png");
const _temp5 = require("./Horseback Riding at Shen.png");
const _temp6 = require("./Johnson Civil Rights Act.png");
const _temp7 = require("./Justice John Marshall Harlan.png");
const _temp8 = require("./Lewis Mountain Picnic Grounds Sign.png");
const _temp9 = require("./Lewis Mountain Store Interior.png");
const _temp10 = require("./Map of Segregated Areas.png");
const _temp11 = require("./Protests.png");
const _temp12 = require("./Shenandoah Mountain Overlook with Cars.png");
const _temp13 = require("./The Negro Motorist Green Book.png");
const _temp14 = require("./Tourists at Hemlock Springs Overlook.png");
module.exports = {
  "Audrey Tutt and Friends": _temp0,
  "Black School Children": _temp1,
  "Cars at Scenic Overlook": _temp2,
  "Couple at Scenic Overlook": _temp3,
  "Elkwallow Picnic Grounds Sign": _temp4,
  "Horseback Riding at Shen": _temp5,
  "Johnson Civil Rights Act": _temp6,
  "Justice John Marshall Harlan": _temp7,
  "Lewis Mountain Picnic Grounds Sign": _temp8,
  "Lewis Mountain Store Interior": _temp9,
  "Map of Segregated Areas": _temp10,
  "Protests": _temp11,
  "Shenandoah Mountain Overlook with Cars": _temp12,
  "The Negro Motorist Green Book": _temp13,
  "Tourists at Hemlock Springs Overlook": _temp14
}